<template>
    <a href="#" class="show-more-item" v-if="numMore > 0" @click="handleClick" tabindex="0">
        <div class="item-box">
            <div>
                <span class="num-more">+{{ numMore }}</span>
                <span class="text-uppercase mb-2">{{ typeText }}</span>
            </div>
        </div>
    </a>
</template>

<script>
/* global Bus */
export default {
  name: 'ShowMoreItem',
  props: ['numMore', 'typeText', 'contentType'],
  methods: {
    handleClick: function () {
      this.$store.commit('setFilters', {
        contentTypes: [this.contentType]
      })
      Bus.$emit('do-perform-search')
    }
  }
}
</script>
